package ru.villawonka.app.presentation.screens.main.compose

import androidx.compose.material.Scaffold
import androidx.compose.runtime.Composable
import cafe.adriel.voyager.core.screen.Screen
import cafe.adriel.voyager.navigator.tab.CurrentTab
import cafe.adriel.voyager.navigator.tab.TabNavigator
import ru.villawonka.app.getTelegram
import ru.villawonka.app.presentation.design.components.AppBottomNavigationBar
import ru.villawonka.app.presentation.design.components.AppBottomNavigationItem
import ru.villawonka.app.presentation.screens.favorites.compose.FavoritesScreen
import ru.villawonka.app.presentation.screens.search.compose.SearchScreen

class MainScreen(private val selectedTab: Tab) : Screen {

    @Composable
    override fun Content() {
        getTelegram()?.setBackButtonVisible(isVisible = false)
        TabNavigator(
            tab = when (selectedTab) {
                Tab.SEARCH -> SearchScreen
                Tab.FAVORITES -> FavoritesScreen
            }
        ) {
            Scaffold(
                content = { CurrentTab() },
                bottomBar = {
                    AppBottomNavigationBar {
                        AppBottomNavigationItem(SearchScreen)
                        AppBottomNavigationItem(FavoritesScreen)
                    }
                }
            )
        }
    }

    enum class Tab {
        SEARCH,
        FAVORITES
    }
}